import angular from 'angular';
import tableGridModalLinkCellComponent from './tableGridModalLinkCell.component';

let tableGridModalLinkCellModule = angular.module('tableGridModalLinkCell', []).directive('tableGridModalLinkCell', tableGridModalLinkCellComponent);

export default tableGridModalLinkCellModule;


// WEBPACK FOOTER //
// ./app/components/tableGridModalLinkCell/tableGridModalLinkCell.js